var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#757a8a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3408 4.63464H5.34082C4.09818 4.63464 3.09082 5.642 3.09082 6.88464V18.8846C3.09082 20.1273 4.09818 21.1346 5.34082 21.1346H20.3408C21.5835 21.1346 22.5908 20.1273 22.5908 18.8846V6.88464C22.5908 5.642 21.5835 4.63464 20.3408 4.63464Z",
    strokeWidth: 1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5908 10.6346C17.4192 10.6346 18.0908 9.96307 18.0908 9.13464C18.0908 8.30622 17.4192 7.63464 16.5908 7.63464C15.7624 7.63464 15.0908 8.30622 15.0908 9.13464C15.0908 9.96307 15.7624 10.6346 16.5908 10.6346Z",
    strokeWidth: 1,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0908 16.6248L10.8411 12.3831C10.5707 12.1127 10.2072 11.9558 9.82502 11.9445C9.4428 11.9332 9.07068 12.0683 8.78473 12.3221L3.09082 17.3846M11.3408 21.1346L17.1224 15.3531C17.3868 15.0881 17.7407 14.9316 18.1146 14.9143C18.4885 14.8969 18.8554 15.02 19.1432 15.2593L22.5908 18.1346",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.4b9b8936.svg";
export { ForwardRef as ReactComponent };